(function () {
  var backdrop = document.getElementById('ww-drawer-backdrop');
  var panel = document.getElementById('ww-drawer-panel');
  var itemsEl = document.getElementById('ww-drawer-items');
  var subtotalEl = document.getElementById('ww-drawer-subtotal');
  var subtotalSavingsEl = document.getElementById('ww-drawer-savings');
  var closeBtn = document.getElementById('ww-drawer-close');
  var continueLink = document.getElementById('ww-drawer-continue');
  if (!backdrop || !panel || !itemsEl) return;

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  function renderItems(cart) {
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="ww-drawer-empty">Your cart is empty.</p>';
      subtotalEl.textContent = formatMoney(0);
      subtotalSavingsEl.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      // Real Shopify-applied discounts only (automatic discounts, discount codes) —
      // item.total_discount/original_line_price come straight from the cart API,
      // never computed or guessed client-side.
      var hasDiscount = item.total_discount > 0;
      var priceHtml = hasDiscount
        ? '<span class="ww-drawer-item-compare">' + formatMoney(item.original_line_price) + '</span>' +
          '<span class="ww-drawer-item-price ww-drawer-item-price--sale">' + formatMoney(item.final_line_price) + '</span>'
        : '<span class="ww-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>';
      var discountLine = '';
      if (hasDiscount && item.discounts && item.discounts.length) {
        var titles = item.discounts.map(function (d) { return d.title; }).filter(Boolean).join(', ');
        discountLine = '<span class="ww-drawer-item-discount">🏷 ' + titles + ' — save ' + formatMoney(item.total_discount) + '</span>';
      }
      html += '' +
        '<div class="ww-drawer-item" data-line="' + (i + 1) + '">' +
          (img ? '<img class="ww-drawer-item-img" src="' + img + '" alt="" loading="lazy">' : '<div class="ww-drawer-item-img"></div>') +
          '<div class="ww-drawer-item-info">' +
            '<span class="ww-drawer-item-title">' + item.product_title + '</span>' +
            (variant ? '<span class="ww-drawer-item-variant">' + variant + '</span>' : '') +
            discountLine +
            '<div class="ww-drawer-item-bottom">' +
              '<div class="ww-drawer-stepper">' +
                '<button type="button" class="ww-drawer-qty-minus" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" class="ww-drawer-qty-plus" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="ww-drawer-item-price-wrap">' + priceHtml + '</span>' +
            '</div>' +
            '<button type="button" class="ww-drawer-item-remove">Remove</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    subtotalEl.textContent = formatMoney(cart.total_price);
    if (cart.total_discount > 0) {
      subtotalSavingsEl.textContent = 'You saved ' + formatMoney(cart.total_discount);
      subtotalSavingsEl.style.display = 'block';
    } else {
      subtotalSavingsEl.style.display = 'none';
    }
  }

  // Every drawer-driven cart mutation (open/refresh, qty +/-, remove) flows through
  // renderItems, so broadcasting from here — rather than from each call site — is
  // the one place that reliably keeps external listeners (e.g. the persistent header/
  // floating cart badges) in sync without them needing their own /cart.js fetch.
  function broadcastCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('ww:cart:updated', { detail: cart }));
  }

  function refresh() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderItems(cart);
        broadcastCartUpdate(cart);
        return cart;
      });
  }

  function open() {
    refresh().then(function () {
      backdrop.classList.add('ww-open');
      panel.classList.add('ww-open');
      panel.setAttribute('aria-hidden', 'false');
      backdrop.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ww-drawer-locked');
    });
  }

  function close() {
    backdrop.classList.remove('ww-open');
    panel.classList.remove('ww-open');
    panel.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ww-drawer-locked');
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderItems(cart);
        broadcastCartUpdate(cart);
      });
  }

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.ww-drawer-item');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var qtyEl = row.querySelector('.ww-drawer-stepper span');
    var qty = parseInt(qtyEl.textContent, 10);
    if (e.target.classList.contains('ww-drawer-qty-plus')) {
      changeLine(line, qty + 1);
    } else if (e.target.classList.contains('ww-drawer-qty-minus')) {
      changeLine(line, Math.max(0, qty - 1));
    } else if (e.target.classList.contains('ww-drawer-item-remove')) {
      changeLine(line, 0);
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  if (continueLink) {
    continueLink.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('ww-open')) close();
  });

  window.WWCartDrawer = { open: open, close: close, refresh: refresh };
})();
